import React from "react";
import styles from "./Headings.module.css";

const Heading: React.FC = ({ children }) => (
  <h3 className={styles.heading}>{children}</h3>
);

export default Heading;
